import { twMerge } from "tailwind-merge";
import type { IconProps } from "./types";

export const Heading3 = ({ size, color, className, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={twMerge(color == null && "h-5 w-5 stroke-current", className)}
    stroke={color}
    fill="none"
    {...props}
  >
    <path
      d="M3.5 5V19M12.5 5V19M5 5H2M12.5 12L3.5 12M5 19H2M14 19H11M14 5H11"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.665 20.098H19.587C19.531 20.098 19.3723 20.0933 19.111 20.084C18.859 20.084 18.6863 20.084 18.593 20.084C18.4996 20.0746 18.3456 20.0653 18.131 20.056C17.9163 20.0373 17.7483 20.0186 17.627 20C17.515 19.9813 17.3703 19.958 17.193 19.93C16.913 19.8833 16.6236 19.8086 16.325 19.706L16.339 18.278H19.895C20.427 18.278 20.8003 18.222 21.015 18.11C21.2203 17.998 21.323 17.7366 21.323 17.326V16.878C21.323 16.486 21.211 16.22 20.987 16.08C20.7723 15.9306 20.4363 15.8466 19.979 15.828L17.193 15.716V14.148L19.979 14.008C20.4736 13.98 20.8283 13.896 21.043 13.756C21.2483 13.6066 21.351 13.3546 21.351 13V12.496C21.351 12.244 21.2856 12.0433 21.155 11.894C21.015 11.7446 20.8516 11.6466 20.665 11.6C20.4783 11.5533 20.2496 11.53 19.979 11.53H16.241V10.116C17.0063 9.84529 18.215 9.70996 19.867 9.70996C20.175 9.70996 20.4736 9.71463 20.763 9.72396C21.5376 9.74263 22.1536 9.97129 22.611 10.41C23.0683 10.8486 23.297 11.4413 23.297 12.188V12.916C23.297 13.98 22.9423 14.6426 22.233 14.904C22.9423 15.2026 23.297 15.9026 23.297 17.004V17.592C23.297 18.404 23.073 19.0246 22.625 19.454C22.177 19.8833 21.5236 20.098 20.665 20.098Z"
      stroke="none"
      className="fill-current"
    />
  </svg>
);
